module.exports = __webpack_public_path__ + "static/media/signage-industrial-img11.68724f91.jpg";